import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Breadcrumbs,
  Link,
  Divider,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Home, Gavel } from '@mui/icons-material';

const TermsOfServicePage = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', py: 4 }}>
      <Container maxWidth="md">
        {/* Breadcrumbs */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link component={RouterLink} to="/" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          <Typography color="text.primary">Terms of Service</Typography>
        </Breadcrumbs>

        {/* Header */}
        <Paper elevation={0} sx={{ p: 4, mb: 4, textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
          <Gavel sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Terms of Service
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
        </Paper>

        {/* Content */}
        <Paper elevation={1} sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing and using Mall of Stones ("we," "our," or "us"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            2. Use License
          </Typography>
          <Typography variant="body1" paragraph>
            Permission is granted to temporarily download one copy of the materials on Mall of Stones for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <Typography component="li" variant="body1" sx={{ mb: 1 }}>
              modify or copy the materials
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 1 }}>
              use the materials for any commercial purpose or for any public display
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 1 }}>
              attempt to reverse engineer any software contained on the website
            </Typography>
            <Typography component="li" variant="body1">
              remove any copyright or other proprietary notations from the materials
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            3. Product Information and Orders
          </Typography>
          <Typography variant="body1" paragraph>
            We strive to provide accurate product descriptions and pricing. However, we do not warrant that product descriptions or other content is accurate, complete, reliable, current, or error-free. All orders are subject to acceptance and availability.
          </Typography>
          <Typography variant="body1" paragraph>
            Prices are subject to change without notice. We reserve the right to refuse or cancel any order for any reason, including but not limited to product availability, errors in product or pricing information, or problems identified by our fraud detection systems.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            4. Payment and Billing
          </Typography>
          <Typography variant="body1" paragraph>
            Payment is due at the time of order placement. We accept various payment methods as displayed during checkout. You are responsible for providing accurate billing information and authorizing the charges.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            5. Shipping and Delivery
          </Typography>
          <Typography variant="body1" paragraph>
            Delivery times are estimates and may vary based on product availability and location. We are not responsible for delays caused by shipping carriers or circumstances beyond our control. Risk of loss passes to you upon delivery.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            6. Returns and Refunds
          </Typography>
          <Typography variant="body1" paragraph>
            Due to the nature of stone products, returns are limited to cases of damage during shipping or significant quality defects. Return requests must be made within 7 days of delivery with photographic evidence. Custom orders and cut-to-size products are non-returnable.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            7. User Accounts
          </Typography>
          <Typography variant="body1" paragraph>
            You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            8. Seller Terms
          </Typography>
          <Typography variant="body1" paragraph>
            Sellers on our platform must provide accurate product information, maintain quality standards, and fulfill orders promptly. Sellers are responsible for their product descriptions, pricing, and customer service. We reserve the right to remove sellers who violate our policies.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            9. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            In no event shall Mall of Stones or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we have been notified orally or in writing of the possibility of such damage.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            10. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These terms and conditions are governed by and construed in accordance with the laws of India, and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            11. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to revise these terms of service at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            12. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about these Terms of Service, please contact us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Email: connect@mallofstones.com<br />
            Phone: +91-9460061819<br />
            Address: Mall of Stones, Jaipur
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage;